export function getFilterPopupContainer(triggerNode: HTMLElement): HTMLElement {
  const folderMetadataOverview = triggerNode.closest('[data-testid="folder-metadata-overview-page"]');
  if (folderMetadataOverview) {
    return folderMetadataOverview as HTMLElement;
  }
  return triggerNode.closest(".ant-drawer-body") ?? triggerNode.closest(".ant-modal-content") ?? document.body;
}
